import _ from 'underscore';

const NonHierarchyColumns = [
  'CompanyName',
];

export const CustomerHierarchyColumns = [
  'AccountType',
  'Owner',
  'ManagerAccounts',
];

export const HiddenCustomerHierarchyColumns = [
  'IsAccountAuthorized',
  'OwnerId',
  'IsParentAuthorized',
  'AccountType',
];

export const HiddenManagementColumns = [
  'IsAccountAuthorized',
  'ManagerAccounts',
  'OwnerId',
  'IsParentAuthorized',
  'AccountType',
];

export const ManualHoldStatusColumns = [
  'LastFinStatusUpdatedSourceBitMap',
  'PaymentOption',
];

export function applyCustomerHierarchyExtrasFilter(columns, isCustomerHierarchyEnabled = false) {
  return isCustomerHierarchyEnabled ? columns.concat(HiddenCustomerHierarchyColumns) : columns;
}

export function applyCustomerHierarchyColumnFilter(columns, isCustomerHierarchyEnabled = false) {
  return isCustomerHierarchyEnabled ? CustomerHierarchyColumns.concat(_.without(columns, 'CompanyName')) : columns;
}

export function customerHierarchyColumnsToIgnore(isCustomerHierarchyEnabled) {
  return isCustomerHierarchyEnabled ? NonHierarchyColumns : CustomerHierarchyColumns;
}

export function applyCustomerHierarchyOrderbyFilter(orderbyInfo, isCustomerHierarchyEnabled = false) {
  return _.reject(orderbyInfo, ({ key }) => _.contains(customerHierarchyColumnsToIgnore(isCustomerHierarchyEnabled), key));
}
